import React from 'react';

import Accordion from  './components/Accordion';
import Anchor from  './components/Anchor';
import HeaderBar from  './components/HeaderBar';
import Icon from  './components/Icon';

const items = [
  {
    header: false,
    child: (
      <p className="pad">
        {`
          TTYL Events has multiple branches of business. Please look below for
          specific topics for contacting us.
        `}
      </p>
    ),
  },
  {
    header: (
      <h5>
        <Icon icon="chevron_right" classNames="margin-r font-size-2" />
        VIP
      </h5>
    ),
    child: (
      <p className="pad">
        Email:
        <Anchor
          id="MailToVip"
          href="mailto:vip@ttylevents.com"
          title="vip@ttylevents.com"
          classNames="ttyl-blue-text pad-lr"
        />
      </p>
    ),
  },
  {
    header: (
      <h5>
        <Icon icon="chevron_right" classNames="margin-r font-size-2" />
        Ticketing
      </h5>
    ),
    child: (
      <p className="pad">
        Email:
        <Anchor
          id="MailToTicketing"
          href="mailto:ticketing@ttylevents.com"
          title="ticketing@ttylevents.com"
          classNames="ttyl-blue-text pad-lr"
        />
      </p>
    ),
  },
  {
    header: (
      <h5>
        <Icon icon="chevron_right" classNames="margin-r font-size-2" />
        Support
      </h5>
    ),
    child: (
      <p className="pad">
        Email:
        <Anchor
          id="MailToSupport"
          href="mailto:support@ttylevents.com"
          title="support@ttylevents.com"
          classNames="ttyl-blue-text pad-lr"
        />
      </p>
    ),
  },
  {
    header: (
      <h5>
        <Icon icon="chevron_right" classNames="margin-r font-size-2" />
        Inquiry
      </h5>
    ),
    child: (
      <p className="pad">
        Email:
        <Anchor
          id="MailToInquiry"
          href="mailto:info@ttylevents.com"
          title="info@ttylevents.com"
          classNames="ttyl-blue-text pad-lr"
        />
      </p>
    ),
  },
  {
    child: (
      <Anchor
        id="ReadOurTerns"
        classNames="btn-primary btn-large black fluid"
        title="Terms & Conditions"
        to="terms"
      />
    )
  }
]

const Contact = () => (
  <section id="ContactUsWrapper" className="margin-tb-2">
    <HeaderBar
      id="ContactUsHeader"
      level={4}
      classNames="row left-align black raised margin-0"
    >
      Contact Us
    </HeaderBar>
    <div className="margin-tb-2">
      <Accordion id="ContactUsContainer" items={items} />
    </div>
  </section>
);

export default Contact;
